import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PartsManagementResponse } from '../../../models/parts-management-response.model';

@Component({
  selector: 'app-parts-management-header',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './parts-management-header.component.html',
  styleUrl: './parts-management-header.component.scss',
})
export class PartsManagementHeaderComponent {
  @Input() partsManagementHeader!: PartsManagementResponse;
}
